export enum LevelId {
    TutorialLevel,
    TheFarm,
    SpidersDen,
    TheWizard,
    TheTroll,
    TheDragon,
    TheNecromancer,
}